// formatClock — split the NVR timestamp ("YYYY-MM-DD HH:MM:SS", the NVR's own local clock) into a
// friendly date + the ticking time, for the Live header clock (#86bb5dx62 — David wants the date
// shown, not just the time). Parses the string by hand (no Date()) so the NVR's wall-clock is shown
// verbatim regardless of the viewer's timezone.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * @param {string} nvrTimestamp e.g. "2026-08-02 14:30:00"
 * @returns {{ date: string, time: string, iso: string }}
 *   date = "Aug 2, 2026" (falls back to the raw date part if it isn't YYYY-MM-DD),
 *   time = "14:30:00", iso = "2026-08-02". All '' when the input is empty/invalid.
 */
export function formatNvrClock(nvrTimestamp) {
  if (!nvrTimestamp || typeof nvrTimestamp !== 'string') return { date: '', time: '', iso: '' };
  const [datePart = '', timePart = ''] = nvrTimestamp.trim().split(' ');
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  let date = datePart;
  if (m) {
    const mon = MONTHS[parseInt(m[2], 10) - 1];
    if (mon) date = `${mon} ${parseInt(m[3], 10)}, ${m[1]}`;
  }
  return { date, time: timePart, iso: datePart };
}
